import { render, staticRenderFns } from "./QuestionnaireBaseModal.vue?vue&type=template&id=2bab5929&scoped=true"
import script from "./QuestionnaireBaseModal.vue?vue&type=script&lang=js"
export * from "./QuestionnaireBaseModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireBaseModal.vue?vue&type=style&index=0&id=2bab5929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab5929",
  null
  
)

export default component.exports